import { AfterViewInit, Component, OnInit } from '@angular/core';
import { INonCNLEmployees } from '../../../interface/administrator/admin';
import { ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { HttpClient } from '@angular/common/http';
import { AdminService } from '../../../services/administrator/admin.service';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { AddUpdateDialogComponent } from './add-update-dialog/add-update-dialog/add-update-dialog.component';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../../shared/module/material.module';
import { SharedServices } from '../../../shared/services/shared.services';
import { ConfirmdialogComponent } from '../../../shared/component/confirmdialog/confirmdialog.component';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-non-cnl-employees',
  imports: [MaterialModule, CommonModule],
  templateUrl: './non-cnl-employees.component.html',
  styleUrl: './non-cnl-employees.component.css'
})
export class NonCnlEmployeesComponent implements OnInit, AfterViewInit {
  title = 'Non CNL Employees Setup';
  isLoading: boolean = false;
  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;
  DisplayedColumns: string[] = [
    'serialNo',
    'empNo',
    'email',
    'surname',
    'firstname',
    'middlename',
    'initials',
    'jobTitle',
    'reportsToCai',
    'costCenter',
    'dept',
    'actions'
  ];
  excelData: any;
  dataSource = new MatTableDataSource<INonCNLEmployees>();
  constructor(private http: HttpClient, private sharedService: SharedServices, private adminservice: AdminService, public dialog: MatDialog) { }
  ngOnInit(): void {
    this.isLoading = true;
    this.getNonCNLEmployees();
  }
  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  getNonCNLEmployees(): Observable<INonCNLEmployees[]> {
    this.adminservice.getNonCNLEmployees()
      .subscribe((data: INonCNLEmployees[]) => {
        this.dataSource = new MatTableDataSource(data);
        this.dataSource.paginator = this.paginator;
        this.isLoading = false;
        this.excelData = this.dataSource.data.map((item, index) => ({
          ...item,
          'S/No': index + 1,
        }));
      }, error => {
        console.error('Error fetching categories', error);
        this.isLoading = false;
      });
      return this.adminservice.getNonCNLEmployees(); 
  }
  openAddDialog(): void {
    const dialogRef = this.dialog.open(AddUpdateDialogComponent, {
      width: '400px',
      height: '500px',
      data: { isEdit: false, existingEmployees: this.dataSource.data },
      panelClass: 'custom-dialog-container'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) this.getNonCNLEmployees();
    });
  } openUpdateDialog(element: INonCNLEmployees): void {
    const dialogRef = this.dialog.open(AddUpdateDialogComponent, {
      width: '400px',
      height: '500px',
      data: { isEdit: true, user: element, existingEmployees: this.dataSource.data },
      panelClass: 'custom-dialog-container'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) this.getNonCNLEmployees();
    });
  }
  removeNonCnlEmployees(element: INonCNLEmployees): void {
    const dialogRef = this.dialog.open(ConfirmdialogComponent, {
      width: 'auto',
      position: { top: '1' },
      data: { message: 'Are you sure you want to delete the Employee?' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.isLoading = true;
        this.adminservice.deleteNonCNLEmployee(element.id).subscribe({
          next: response => {
            this.getNonCNLEmployees().subscribe({
              next: () => {
                this.sharedService.openModal('Message', 'Removed Successfully');
                this.isLoading = false;
              },
              error: error => {
                console.error('Error fetching non cnl employees', error);
                this.isLoading = false;
              }
            });
          },
          error: error => {
            console.error('Error removing non cnl employees', error);
            this.isLoading = false;
          }
        });
      }
    });
  }
  applyFilter(event: Event, column: string): void {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filterPredicate = (data: INonCNLEmployees, filter: string) => {
      const filters = JSON.parse(filter);
      return Object.keys(filters).every(key => {
        const textToSearch = data[key as keyof INonCNLEmployees] && data[key as keyof INonCNLEmployees].toString().toLowerCase() || '';
        return textToSearch.indexOf(filters[key]) !== -1;
      });
    };

    const currentFilters = this.dataSource.filter ? JSON.parse(this.dataSource.filter) : {};
    currentFilters[column] = filterValue;
    this.dataSource.filter = JSON.stringify(currentFilters);

    const filteredData = this.dataSource.filteredData.map((item, index) => ({
      ...item,
      'S/No': index + 1,
    }));
    this.excelData = filteredData;
  }
  downloadExcel(): void {
    this.adminservice.getNonCNLEmpWorksheet(this.excelData).subscribe(
      (data: Blob) => {
        const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `NonCNLEmployeesList_${new Date().toISOString().slice(0, 19).replace(/:/g, '-')}.xlsx`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      },
      error => {
        console.error('Error downloading the file', error);
      }
    );
  }
}
